import { PurchaseProductDetails } from '@ancon/wildcat-types'

import { ProductConfigureAccordionId } from '../constants'

import getAddonGroupDisplayOrder from './getAddonGroupDisplayOrder'

/**
 * Get the initial active accordion id based on the product details
 * In order of priority:
 * 1. Variants
 * 2. Addon groups (the first one shown, so a required group when there is one)
 *
 * The ingredient accordion is always collapsed by default
 */
export default function getInitialActiveAccordionId(
  productDetails: Pick<
    PurchaseProductDetails,
    'hasVariants' | 'hasAddOnGroups' | 'variants' | 'addOnGroups'
  >,
) {
  const { hasVariants, hasAddOnGroups, variants, addOnGroups } = productDetails

  const hasMultipleVariants = variants.length > 1

  if (hasVariants && (hasMultipleVariants || !hasAddOnGroups)) {
    return ProductConfigureAccordionId.Variants
  }

  const [firstShownAddonGroupIndex] = getAddonGroupDisplayOrder(addOnGroups)

  if (hasAddOnGroups && firstShownAddonGroupIndex !== undefined) {
    return ProductConfigureAccordionId.AddonGroup(firstShownAddonGroupIndex)
  }

  return undefined
}
